import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import cookies from './util.cookies';
import db from './util.db';
import log from './util.log';
var util = {
  cookies: cookies,
  db: db,
  log: log
};

/**
 * @description 更新标题
 * @param {String} title 标题
 */
util.title = function (titleText) {
  var processTitle = process.env.VUE_APP_TITLE || 'D2Admin';
  window.document.title = "".concat(processTitle).concat(titleText ? " | ".concat(titleText) : '');
};

/**
 * @description 打开新页面
 * @param {String} url 地址
 */
util.open = function (url) {
  var a = document.createElement('a');
  a.setAttribute('href', url);
  a.setAttribute('target', '_blank');
  a.setAttribute('id', 'd2admin-link-temp');
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(document.getElementById('d2admin-link-temp'));
};
util.changeMenu = function (menu) {
  var changedMenu = [];
  menu.forEach(function (m) {
    var o = {
      path: m.href,
      title: m.name,
      icon: m.icon
    };
    if (m.lowerMenus.length > 0) {
      o.path = m.id;
      o.children = util.changeMenu(m.lowerMenus);
    }
    changedMenu.push(o);
  });
  return changedMenu;
};
export default util;